<template>
    <layout title="Cottonseed Bids">
        <div class="px-8">
            <div class="flex justify-between items-center">
                <div class="font-semibold text-lg">
                    Cottonseed Bids
                </div>
                <div>
                    <div>
                        <nav class="flex space-x-4" aria-label="Tabs">
                            <!-- Current: "bg-indigo-100 text-indigo-700", Default: "text-gray-500 hover:text-gray-700" -->
                            <a @click.prevent="showOpen = 1" href="#" :class="[ showOpen ? 'bg-blue-100 text-blue-700' : 'text-gray-500 hover:text-gray-700', 'px-3 py-2 font-medium text-sm rounded-md']">
                                Open
                            </a>

                            <a @click.prevent="showOpen = 0" href="#" :class="[ ! showOpen ? 'bg-blue-100 text-blue-700' : 'text-gray-500 hover:text-gray-700', 'px-3 py-2 font-medium text-sm rounded-md']">
                                Accepted
                            </a>
                        </nav>
                    </div>
                </div>
            </div>
            <cottonseed-bids-list v-show="showOpen" :items="items"></cottonseed-bids-list>
            <cottonseed-bids-accepted-list v-show="!showOpen" :items="accepted"></cottonseed-bids-accepted-list>
        </div>
    </layout>
</template>

<script>

import Layout from "@/Shared/Layout";
import CottonseedBidsList from "@/Components/CottonseedBidsCustomers/CottonseedBidsList";
import CottonseedBidsAcceptedList from "@/Components/CottonseedBidsCustomers/CottonseedBidsAcceptedList";

export default {
    components: {CottonseedBidsAcceptedList, CottonseedBidsList, Layout},
    props: {
        items: {
            type: Array,
            default: []
        },
        accepted: {
            type: Array,
            default: []
        },
    },
    data() {
        return {
            showOpen: 1
        }
    }
}
</script>
